import { FC } from "react";
import { useTableSearch } from "../useTableSearch";
import { TableContent } from "./TableContent";
import { TableFilters } from "./TableFilters";
import { TableSearch } from "./TableSearch";
import { TABLE_TYPES } from "../tableTypes";

export interface IInclusionRow {
  title: string;
  organisation: string;
  type?: string[];
  cta_attachment?: string[];
  cta_tool?: string;
  description: string;
  image?: string;
  spotlight: boolean;
  target_audience?: string[];
  theme?: string[];
}

interface Props {
  rows: IInclusionRow[];
}

const tableHeaders: { [key: string]: string } = {
  title: "Titel",
  organisation: "Organisatie",
  type: "Type",
  target_audience: "Doelgroep",
};

export const TableWrapper: FC<Props> = ({ rows }) => {
  const {
    state: {
      sortColumn,
      sortDirection,
      themaOptions,
      targetAudienceOptions,
      materialOptions,
      filteredRows,
      favorites,
    },
    actions: {
      setSearch,
      setThema,
      setTargetAudience,
      setMaterial,
      handleSort,
      addToFavorites,
      removeFromFavorites,
    },
  } = useTableSearch({ rows });

  return (
    <>
      <TableSearch setSearch={setSearch} />
      <TableFilters
        themaOptions={themaOptions}
        targetAudienceOptions={targetAudienceOptions}
        materialOptions={materialOptions}
        setThema={setThema}
        setTargetAudience={setTargetAudience}
        setMaterial={setMaterial}
      />
      <div style={{ width: "100%", overflowX: "auto", marginBottom: "48px" }}>
        <TableContent
          filteredRows={filteredRows}
          sortColumn={sortColumn}
          sortDirection={sortDirection}
          handleSort={handleSort}
          favorites={favorites}
          addToFavorites={addToFavorites}
          removeFromFavorites={removeFromFavorites}
          tableHeaders={tableHeaders}
          tableType={TABLE_TYPES.INCLUSION}
        />
      </div>
    </>
  );
};
